module.exports = __webpack_public_path__ + "img/china-resources.b0c54e5d.png";